import React, { useState, useRef, useEffect, Fragment } from "react";
import "./../components/Report.scss";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import Cards from "../components/Cards";
import Bar from "../components/Bar";
import MultipleBarCharts from "../components/MultipleBarCharts";
import MultipleLineCharts from "../components/MultipleLineCharts";
import "../components/Report.scss";
import FeatureIcon from "mdi-react/CheckCircleOutlineIcon";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  _replaceAbbreviations,
  _formatBed,
  _isEqual,
  _tranformTagsQuery,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  _activityFL,
  _getFeaturesArr,
  _chunkArray,
  _isCoop,
  _validUnitSources,
  propertyExportFL,
  propertyFL,
  _formatNum,
  _getBuildingPhotos,
  _getServiceLevel,
  _checkBuildingAltAdr,
} from "../../../../../../shared/helpers/utils";
import { amenitiesList } from "../../../../../../shared/helpers/bp-utils.js";
import { userEditFieldsObj } from "../../../../../../shared/helpers/userEditFields.js";
import {
  generatePeriodNames,
  prepareResForAI,
  filterAIData,
  getCurrentPeriod,
  getPriorPeriod,
  getRangeEnd,
  getRangeStart,
  formatDate,
  validateNestedData,
  formatDateRange,
  percentageChange,
} from "../../../exportreport/utils";
import CustomTable from "../../components/CustomTable";
import CustomBarChart from "../components/CustomBarChart";
import { height } from "@material-ui/system";
import Amenities from "../components/Amenities";
import { building } from "../../../../../DataExport/components/EmptyExportList/components/EmptyList";
import { formValues } from "redux-form";
import Footer from "./../../reports/components/Footer";
import { Skeleton } from "@material-ui/lab";
import CustomSkeleton from "../components/Skeleton.jsx";
import CoverPage from "./../../reports/components/CoverPage";

const apiURL = process.env.API_ROOT;

let statTypes = [
  {
    key: "residential_sales",
    title: "Condo, Co-op and Single-Family Homes",
    name: "Market Overview",
    checkedColor: "#D5E1A3",
    activitesQuery: "event_tags:(condo* co?op* coop* condo*p single?family)",
    default: true,
  },

  {
    key: "condo",
    title: "New and Resale Condos",
    name: "Condo",
    checkedColor: "#780F9E",
    activitesQuery:
      '(event_tags:(condo* !condo*p) AND -address_2_normalized:"")',
    default: true,
  },
  {
    key: "coop",
    title: "New and Resale Co-ops",
    name: "Co-op",
    checkedColor: "#28C2FF",
    activitesQuery:
      '(event_tags:(co?op* coop* condo*p) AND -address_2_normalized:"")',
    default: true,
  },
  {
    key: "single_family",
    title: "Townhouses and Detached Single-Family Homes",
    name: "Single-Family",
    checkedColor: "#FFD23F",
    activitesQuery: "(event_tags:(single?family))",
  },
];

const statFacet = {
  med_price: "percentile(price, 50)",
  by_borough: {
    type: "terms",
    field: "borough",
    facet: {
      med_price: "percentile(price, 50)",
    },
  },
  ppsf: {
    type: "query",
    q: "sq_ft:[300 TO 20000]",
    facet: {
      med: "percentile(div(price, sq_ft), 50)",
    },
  },
  dom: {
    type: "query",
    q: "days_on_market:[3 TO 720]",
    facet: {
      med: "percentile(days_on_market, 50)",
    },
  },
  under_one: {
    type: "query",
    q: "price:[10000 TO 999999]",
  },
  one_to_two: {
    type: "query",
    q: "price:[1000000 TO 1999999]",
  },
  two_to_four: {
    type: "query",
    q: "price:[2000000 TO 3999999]",
  },
  four_to_ten: {
    type: "query",
    q: "price:[4000000 TO 9999999]",
  },
  ten_plus: {
    type: "query",
    q: "price:[10000000 TO 350000000]",
  },
};

const BlendedLayout = (props) => {
  console.log(props, "chintanProps")
  const {
    fetchInProgress,
    setFetchInProgress,
    user,
    reportLoaded,
    setReportLoaded,
    reportData,
    setReportData,
    searchTags,
    summarizeGeographies,
    customDate,
    submit,
    setSubmit,
    color,
    theme,
setAiResponse,
AiResponse,
setFetchAi,
fetchAi,
setAIInProgress
  } = props;

  const { dateOptions } = customDate;
  const currentPeriod = getCurrentPeriod(dateOptions);
  const priorPeriod = getPriorPeriod(dateOptions);

  const priorYearPeriod = priorPeriod;
  const rangeEnd = getRangeEnd(dateOptions);
  const rangeStart = getRangeStart;
  const gap = dateOptions.gap;
  const currentPeriodName = generatePeriodNames(dateOptions).currentPeriod;
  const priorYearPeriodName = generatePeriodNames(dateOptions).priorYearPeriod;
  useEffect(() => {
    console.log(reportData, fetchInProgress, submit, "mySubmit");
  
    if (!reportData && !fetchInProgress && submit) {
      const fetchData = async () => {
        await loadData(); 


      };
  
     fetchData();
  
      setSubmit(false);
   
    }
  }, [submit]);
 
   
  useEffect(() => {
    console.log(reportData, fetchAi)
      const fetchAIData = async () => {
       setFetchAi &&  setFetchAi(false);
       setAIInProgress(true);
       const listingResponse = await _getBuildingListingData(
        reportData.buildingRes.building[0]
      );
      // const activityRes=reportData.activityFullRes
      const aiResponse = await handleAIGenerate(
        reportData.buildingRes.building[0],
        reportData.statsRes,
        reportData.activityRes ,
        reportData.priceTrendRes,
        reportData.transactionalRes,
        listingResponse
      );
   
        setAiResponse &&  setAiResponse(aiResponse);
        setAIInProgress(false);
      };
    
      if ( reportData && fetchAi) {
        fetchAIData();
        
      }
    }, [reportData, fetchAi])
//   useEffect(() => {
//     const fetchAIData = async () => {
     
  
      
//       const listingResponse = await _getBuildingListingData(
//         reportData.buildingRes.building[0]
//       );
//       const activityRes=reportData.activityFullRes
//       const aiResponse = await handleAIGenerate(
//         reportData.buildingRes.building[0],
//         reportData.statsResponse,
//         activityRes ,
//         reportData.priceTrendResponse,
//         reportData.transactionalResponse,
//         listingResponse
//       );
 
//     setAiResponse &&  setAiResponse(aiResponse);
// setFetchAi &&  setFetchAi(false)
    
//     };
  
//     if ( reportData && fetchAi) {
//       fetchAIData();
      
//     }
//   }, [reportData, fetchAi])
  const loadData = async () => {
    let q = "*:*";
    let locQuery = _tranformTagsQuery(searchTags);

    if (locQuery) {
      q = locQuery;
    }

    const defaultQ = getCohortQuery(user, true);
    const fq = [
      ..._activityFQ.slice(),
      ...[
        `{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultQ}`,
      ],
    ];
    setFetchInProgress(true);

    const buildingSlug =
      searchTags &&
      searchTags[0] &&
      searchTags[0].data &&
      searchTags[0].data.building_slugs &&
      searchTags[0].data.building_slugs[0];

    let axiosData = {
      url:
        process.env.API_ROOT +
        `/buildings/${buildingSlug}?type=minimum&cache=15`,
      method: "get",
    };

    let res = await _axiosCall(axiosData)
      .then(async (res) => {
        let aiData;

        if (res && res.building) {
          // aiData = prepareResForAI(JSON.parse(JSON.stringify(res.facets)));
          // //
          // res["aiResponse"] = aiResponse;
          const statsResponse = await _getBuildingOPData(res.building[0]);
          const tableResponse = await _getBuildingTransactionTableData(
            res.building[0]
          );

          const activityResponse = await getContractActivity(res.building[0]);
          const priceTrendResponse = await getPriceTrends(res.building[0]);
          const transactionalResponse = await _getBuildingTransactionChartData(
            res.building[0]
          );
 
        
          setReportData({
            buildingRes: res,
            statsRes: statsResponse,
            tableRes: tableResponse,
            activityRes: activityResponse,
            priceTrendRes: priceTrendResponse,
            transactionalRes: transactionalResponse,
          });
       
        }
        return res;
      })
      .catch((error) => {
        console.log("error: " + error);
      })
      .finally(() => {
        setFetchInProgress(false);
        setReportLoaded(true);
        setSubmit(false);
        setFetchAi && setFetchAi(true);
 
      });
  };


  const _getBuildingTransactionTableData = async (buildingRes) => {
    const addressQ = buildingRes.alternate_addresses.join('" OR "');
    const fq = [
      `alternate_addresses:("${addressQ}") AND -address_2_normalized:"" AND (zip:${
        buildingRes.zip
      } OR borough:"${buildingRes.borough.toLowerCase()}")`,
      "status:sold",
      "transaction_source:ACRIS*",
      "price:[50000 TO *]",
      "parcels_condocoop_count:[1 TO 2]",
      "-property_type:sr",
      "-property_type:ps",
      "close_date_formatted:[2014-10-30T18:30:00Z TO NOW]",
    ];
    let axiosData = {
      url: apiURL + "/query/we3-transactions?cache=60",
      method: "post",
      query: {
        q: "*:*",
        sort: "close_date_formatted desc, address_2_normalized asc",
        wt: "json",
        fq: fq,
        rows: 20,
      },
    };
    let tableData = await _axiosCall(axiosData);
    let refinedData = [];
    if(tableData && tableData.docs){
       let tData = {};
       tableData.docs.map(item => {
         if(item.sales_document_ids && item.sales_document_ids[0]){
            if(tData[item.sales_document_ids[0]]){
               tData[item.sales_document_ids[0]]['address_2_normalized'] += ", " + item["address_2_normalized"];
            }else{
              tData[item.sales_document_ids[0]] = item;
            }
            
         }
         
       })
       Object.keys(tData).forEach(k=>{
         refinedData.push(tData[k]);
       })
    }

    return refinedData.slice(0,10);
  };
  const _getBuildingListingData = async (buildingRes) => {
    const fq = [
      `building:${buildingRes.key}`,
      "source_namespace:(BKMLS REBNY-VOW MARKETPROOF-ONEKEY)",
      "listing_type:sale",
      "active_date_start:[NOW-60MONTHS TO NOW]",
    ];
    let axiosData = {
      url: apiURL + "/query/search-listings?cache=60",
      method: "post",
      query: {
        q: "*:*",
        sort: "active_date_start desc",
        wt: "json",
        fl: "description",
        fq: fq,
        rows: 1,
      },
    };
    let tableData = await _axiosCall(axiosData);

    return tableData;
  };
  const _getBuildingOPData = async (buildingRes) => {
    const resaleTimePeriod = 2;
    const addressQ = buildingRes.alternate_addresses.join('" OR "');
    let q = `(alternate_addresses:("${addressQ}") AND (zip:${
      buildingRes.zip
    } OR borough:"${buildingRes.borough.toLowerCase()}"))`;

    let statsQ = "";

    let isCoop = _isCoop(buildingRes);
    let isHouse = _isHouse(buildingRes);

    if (!isHouse) {
      if (["active"].indexOf(buildingRes.offering_verified_status) >= 0) {
        statsQ = `((offering_verified_status:active AND source_organizations:(CDEC NYAG ADEC) AND baths:[1 TO *]) OR verification_source:(user-verified-valid CDEC ADEC))`;
        q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}))`;
      } else if (
        buildingRes.cdec_date &&
        parseInt(moment(buildingRes.cdec_date).format("YYYY")) > 1970 &&
        !isCoop
      ) {
        let unitSource = "source_organizations:(CDEC ADEC)";
        if (
          buildingRes.cdec_units_properties <
          buildingRes.inventory_total * 0.8
        ) {
          unitSource = `(source_organizations:(CDEC ADEC) OR verification_source:(${_validUnitSources}))`;
        }
        statsQ = `(${unitSource} AND property_type:("" *condo* "resident manager unit" *coop* *affordable*) AND -property_type:*commercial* AND -property_type:*multi*)`;
        q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}) OR (current_status:(active \"in contract\")))`;
      } else if (
        ["coming soon"].indexOf(buildingRes.offering_verified_status) >= 0
      ) {
        statsQ = `(source_organizations:NYAG AND offering_baths:[1 TO *] AND offering_price:* AND -offering_file_number:"")`;
        q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}) OR (current_status:(active \"in contract\")))`;
      } else if (!isCoop) {
        q += ` AND (source_organizations:(CDEC ADEC) OR verification_source:(${_validUnitSources}) OR (current_status:(active \"in contract\")))`;
      }
    }
    const isResale =
      ["pipeline", "sponsor"].indexOf(buildingRes.building_status) < 0;

    if (statsQ.length > 0) {
      statsQ = "AND " + statsQ;
    }

    q = q;
    const priceField = isResale
      ? "last_sold_price"
      : "last_listed_sale_price_all";
    let fq = [
      "-deleted:true",
      "-offering_unit_abandoned:true",
      '-address_2_normalized:""',
      `-offering_verified_status:stalled`,
    ];
    let fl = [
      ...propertyExportFL,
      ...[
        "floor",
        "line",
        "offering_submitted_date",
        "div(last_sold_price, sq_ft)",
        "div(last_listed_sale_price_all, sq_ft)",
        "div(last_contract_price, sq_ft)",
        "offering_exterior_sq_ft",
        "times_exchanged",
        "last_exchanged_date",
        "*floorplan*",
      ],
    ];
    if (isHouse) {
      fq = [
        "-deleted:true",
        "-offering_unit_abandoned:true",
        'address_2_normalized:""',
      ];
      fl = [...propertyFL, ...["description"]];
    }

    let axiosData = {
      url: apiURL + "/query/" + "we3-properties?cache=15",
      method: "post",
      query: {
        q: q,
        fq: fq,
        fl: fl,
        sort: "floor asc, address_2_normalized asc",
        wt: "json",
        rows: 0,
        "json.facet": {
          avg_price: `avg(${priceField})`,
          avg_sq_ft: "avg(sq_ft)",
          low_bed: "min(bedrooms)",
          has_bed: {
            type: "query",
            q: `bedrooms:[0 TO *] AND -property_type:"resident manager unit"`,
            facet: {
              unit_mix: {
                type: "terms",
                field: "bedrooms",
                facet: {
                  avg_unit_size: "avg(sq_ft)",
                  med_unit_size: "percentile(sq_ft,0,50,100)",

                  non_zero_price: {
                    type: "query",
                    q: `${priceField}:[100 TO *] AND sq_ft:[100 TO *] ${statsQ}`,
                    facet: {
                      avg_unit_size: "avg(sq_ft)",
                      med_unit_size: "percentile(sq_ft,25,50,75)",
                      avg_fees: "avg(offering_monthly_fees)",
                      med_fees: "percentile(offering_monthly_fees,25,50,75)",
                      avg_taxes: "avg(offering_monthly_taxes)",
                      med_taxes: "percentile(offering_monthly_taxes,25,50,75)",
                      avg_ppsf: `avg(div(${priceField}, sq_ft))`,
                      min_price: `min(${priceField})`,
                      max_price: `max(${priceField})`,
                      avg_monthly_carrying_charges:
                        "avg(offering_monthly_carrying_charges)",
                    },
                  },
                  by_status: {
                    type: "terms",
                    field: "offering_status",
                  },
                },
              },
            },
          },
          non_zero_price: {
            type: "query",
            q: `${priceField}:[100000 TO *] AND sq_ft:[100 TO *] ${statsQ} AND property_type:("" *condo* "resident manager unit" *coop* *affordable*) AND -property_type:*commercial* AND -property_type:*multi*`,
            facet: {
              low_price: `min(${priceField})`,
              high_price: `max(${priceField})`,
              average_price: `avg(${priceField})`,
              average_sq_ft: `avg(${priceField})`,
              sum_price: `sum(${priceField})`,
              low_sq_ft: `min(sq_ft)`,
              high_sq_ft: `max(sq_ft)`,
              low_bed: `min(bedrooms)`,
              high_bed: `max(bedrooms)`,
            },
          },
          total_sold: {
            type: "query",
            q: `last_listed_sale_price_all:[1 TO *] AND offering_status:(not_yet_recorded OR sold OR closed OR resale OR *contract* OR *pending*) ${statsQ}`,
            facet: {
              low_price: "min(last_listed_sale_price_all)",
              high_price: "max(last_listed_sale_price_all)",
              average_price: "avg(last_listed_sale_price_all)",
              average_sq_ft: "avg(last_listed_sale_price_all)",
              sum_price: "sum(last_listed_sale_price_all)",
              low_sq_ft: "min(sq_ft)",
              high_sq_ft: "max(sq_ft)",
              low_bed: "min(bedrooms)",
              high_bed: "max(bedrooms)",
              by_neighborhood: {
                type: "terms",
                field: "neighborhood",
                sort: "avg_ppsf desc",
                limit: 20,
                facet: {
                  avg_price: "avg(offering_price)",
                  avg_ppsf: "avg(div(offering_price, sq_ft))",
                },
              },
            },
          },
          total_sellout: {
            type: "query",
            q: `last_listed_sale_price_all:[1 TO *]  ${statsQ} AND -property_type:"resident manager unit"`,
            facet: {
              low_price: "min(last_listed_sale_price_all)",
              high_price: "max(last_listed_sale_price_all)",
              average_price: "avg(last_listed_sale_price_all)",
              average_sq_ft: "avg(last_listed_sale_price_all)",
              sum_price: "sum(last_listed_sale_price_all)",
              sum_sq_ft: "sum(sq_ft)",
              low_sq_ft: "min(last_listed_sale_price_all)",
              high_sq_ft: "max(sq_ft)",
              low_bed: "min(offering_bedrooms)",
              high_bed: "max(offering_bedrooms)",
              sold_volume: {
                type: "query",
                q: "offering_status:(not_yet_recorded OR sold OR closed OR resale OR *contract* OR *pending*)",
                facet: {
                  sum_price: "sum(last_listed_sale_price_all)",
                  sum_sq_ft: "sum(sq_ft)",
                },
              },
            },
          },
          total_sq_ft: {
            type: "query",
            q: `sq_ft:[1 TO *]  ${statsQ} AND property_type:("" *condo* "resident manager unit" *coop* *affordable*)`,
            facet: {
              avg_sq_ft: "avg(sq_ft)",
              sum_sq_ft: "sum(sq_ft)",
            },
          },
          first_sold: {
            type: "query",
            q: `last_sold_date:[1000 TO *] ${statsQ}`,
            facet: {
              first_sold_date: "min(last_sold_date)",
            },
          },
          sold_1_yr: {
            type: "query",
            q: `last_contract_date_formatted:[NOW-1YEAR TO NOW]`,
          },
          sold_3_mo: {
            type: "query",
            q: `last_contract_date_formatted:[NOW-3MONTH TO NOW]`,
          },
          sold_6_mo: {
            type: "query",
            q: `last_contract_date_formatted:[NOW-6MONTH TO NOW]`,
          },
          listed_1_yr: {
            type: "query",
            q: `last_listed_sale_listed_date_all:[${moment()
              .endOf("day")
              .add(-1, "year")
              .unix()} TO ${moment().endOf("day").unix()}]`,
          },
          listed_3_mo: {
            type: "query",
            q: `last_listed_sale_listed_date_all:[${moment()
              .endOf("day")
              .add(-3, "month")
              .unix()} TO ${moment().endOf("day").unix()}]`,
          },
          listed_6_mo: {
            type: "query",
            q: `last_listed_sale_listed_date_all:[${moment()
              .endOf("day")
              .add(-6, "month")
              .unix()} TO ${moment().endOf("day").unix()}]`,
          },

          by_status: {
            type: "query",
            q: `property_status:sponsor ${statsQ} AND -property_type:"resident manager unit" AND property_type:(*residential*condo* condo "condo unit" *coop* *affordable* "" *dwelling* *timeshare* *residential* *apartment*)`,
            facet: {
              sponsor: {
                type: "terms",
                field: "current_status",
              },
            },
          },
          resale: {
            type: "query",
            q: `-property_status:sponsor ${statsQ} AND -property_type:"resident manager unit" AND property_type:(*residential*condo* condo "condo unit" *coop* *affordable* "" *dwelling* *timeshare* *residential* *apartment*)`,
          },
          ppsf: {
            type: "query",
            q: `last_listed_sale_price_all:[500000 TO 300000000] AND sq_ft:[100 TO *]  ${statsQ} ${
              isResale
                ? " AND last_listed_sale_date_all:[" +
                  Math.round(
                    moment()
                      .endOf("day")
                      .add(-1 * resaleTimePeriod, "year")
                      .valueOf() / 1000
                  ) +
                  " TO *]"
                : ""
            }`,
            facet: {
              sum_listed_price: "sum(last_listed_sale_price_all)",
              avg_listed_price: "avg(last_listed_sale_price_all)",
              sum_sq_ft: "sum(sq_ft)",
              avg_ppsf: "avg(div(last_listed_sale_price_all, sq_ft))",
            },
          },
          original_owner: {
            type: "query",
            q: `times_exchanged:[0 TO *] AND owner:* ${statsQ}`,
            facet: {
              times_sold: {
                type: "terms",
                field: "times_sold",
              },
              times_exchanged: {
                type: "terms",
                field: "times_exchanged",
              },
            },
          },
          corp_owner: {
            type: "query",
            q: `(owner:(*LLC *INC *CORP *TRUST *L.P. *AUTHORITY *ASSOCIATES *COMPANY *L.L.C) OR owner:(*llc *inc *corp *trust *l.p. *authority *associates *company *l.l.c)) ${statsQ}`,
          },
          has_rented: {
            type: "query",
            q: `last_listed_rent_date:[1000 TO *] ${statsQ}`,
          },
        },
      },
    };
    if (isHouse) {
      delete axiosData["query"]["json.facet"];
    }
    let formattedData = await _axiosCall(axiosData);

    return formattedData;
  };
  const getContractActivity = async (buildingRes) => {
    const defaultQ = getCohortQuery(user, true);
    const fq = [
      ..._activityFQ.slice(),
      ...[
        `{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultQ} AND (((neighborhood:"${buildingRes.neighborhood[0].toLowerCase()}" OR markets_major:"${
          buildingRes.markets_sub[0]
        }") AND borough:"${buildingRes.borough.toLowerCase()}"))`,
      ],
    ];
    const statfacet = {
      total_price: "sum(price)",
      buildings: "unique(building)",
      newdev: {
        type: "query",
        q: 'event_tags:(event-stage_sponsor) AND -address_2_normalized:""',
      },
      resale_condo: {
        type: "query",
        q: 'event_tags:(event-stage_unknown event-stage_resale) AND event_tags:(condo* !condo*p) AND -address_2_normalized:""',
      },
      resale_coop: {
        type: "query",
        q: 'event_tags:(event-stage_unknown event-stage_resale) AND event_tags:(co?op* coop* condo*p) AND -address_2_normalized:""',
      },
    };
    let axiosData = {
      url: apiURL + "/query/we3-activities-3?cache=60",
      method: "post",
      query: {
        q: "*:*",
        fq: fq,
        wt: "json",
        rows: 0,
        "json.facet": {
          contract_signed: {
            type: "query",
            q: `topic:listings AND event_tags:contract-signed AND -event_tags:rent AND -event_tags:*commercial*`,
            facet: {
              current_period: {
                type: "query",
                q: `time:${currentPeriod}`,
                facet: statfacet,
              },
              prior_year_period: {
                type: "query",
                q: `time:${priorYearPeriod}`,
                facet: statfacet,
              },
              by_time: {
                range: {
                  field: "time",
                  start: rangeStart,
                  end: rangeEnd,
                  gap: gap,
                  facet: statfacet,
                },
              },
            },
          },
        },
      },
    };
    let res = await _axiosCall(axiosData);
    return res;
  };
  const getPriceTrends = async (buildingRes) => {
    const defaultQ = getCohortQuery(user, true);
    const fq = [
      "close_date_formatted:[2014-10-30T18:30:00Z TO NOW]",
      "status:sold",
      "transaction_source:ACRIS*",
      "price:[50000 TO *]",
      "parcels_condocoop_count:1",
      `{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultQ}`,
    ];

    let axiosData = {
      url: apiURL + "/query/we3-transactions?cache=60",
      method: "post",
      query: {
        q: `(((neighborhood:"${buildingRes.neighborhood[0].toLowerCase()}" OR markets_major:"${
          buildingRes.markets_sub[0]
        }") AND borough:"${buildingRes.borough.toLowerCase()}"))`,
        fq: fq,
        fl: null,
        rows: 0,
        start: 0,
        wt: "json",
        "json.facet": {
          condo: {
            type: "query",
            q: "price_per_sqft:[300 TO 20000] AND ownership_type:(*condo* !condo*p) AND -(sponsored_sale:true) AND property_type:(sc mc sp mp) AND parcels_condocoop_count:1",
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: rangeStart,
                  end: rangeEnd,
                  gap: gap,
                  facet: {
                    avg_ppsf: "avg(price_per_sqft)",
                    med_ppsf: "percentile(price_per_sqft, 50)",
                    avg_price: "avg(price)",
                  },
                },
              },
            },
          },
          coop: {
            type: "query",
            q: "price_per_sqft:[300 TO 20000] AND ownership_type:(*co?op* *coop* condo*p) AND -(sponsored_sale:true AND ownership_type:*condo*) AND property_type:(sc mc sp mp) AND parcels_condocoop_count:1",
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: rangeStart,
                  end: rangeEnd,
                  gap: gap,
                  facet: {
                    avg_ppsf: "avg(price_per_sqft)",
                    med_ppsf: "percentile(price_per_sqft, 50)",
                    avg_price: "avg(price)",
                  },
                },
              },
            },
          },
          newdev: {
            type: "query",
            q: "price_per_sqft:[300 TO 20000] AND (sponsored_sale:true AND ownership_type:*condo*) AND property_type:(sc mc sp mp) AND parcels_condocoop_count:1",
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: rangeStart,
                  end: rangeEnd,
                  gap: gap,
                  facet: {
                    avg_ppsf: "avg(price_per_sqft)",
                    med_ppsf: "percentile(price_per_sqft, 50)",
                    avg_price: "avg(price)",
                  },
                },
              },
            },
          },
        },
      },
    };
    let res = await _axiosCall(axiosData);

    const transformData = (data) => {
      const newDevData =
        data &&
        data.newdev &&
        data.newdev.by_time &&
        data.newdev.by_time.buckets
          ? data.newdev.by_time.buckets
          : [];
      const condoData =
        data && data.condo && data.condo.by_time && data.condo.by_time.buckets
          ? data.condo.by_time.buckets
          : [];
      const coopData =
        data && data.coop && data.coop.by_time && data.coop.by_time.buckets
          ? data.coop.by_time.buckets
          : [];

      const combinedData = {};

      const addData = (category, item) => {
        const date = item.val;

        if (!combinedData[date]) {
          combinedData[date] = {
            value: date,
            condo: { count: 0, ...item.condoDetails },
            coop: { count: 0, ...item.coopDetails },
            newdev: { count: 0, ...item.newdevDetails },
          };
        }
        combinedData[date][category] = {
          count: item.count || 0,
          ...item,
        };
      };

      newDevData.forEach((item) => addData("newdev", item));
      condoData.forEach((item) => addData("condo", item));
      coopData.forEach((item) => addData("coop", item));

      return Object.values(combinedData);
    };

    let transformedData = transformData(res.facets);

    return transformedData;
  };
  function getYearsFromNow(targetYear) {
    const currentYear = new Date().getFullYear();
    return Math.abs(targetYear - currentYear);
  }
  const _getBuildingTransactionChartData = async (buildingRes) => {
    const isResale =
      ["pipeline", "sponsor"].indexOf(buildingRes.building_status) < 0;
    const resaleTimePeriod = isResale
      ? 2
      : getYearsFromNow(
          buildingRes.year_converted &&
            buildingRes.year_converted > buildingRes.year_built
            ? buildingRes.year_converted
            : buildingRes.year_built
        );
    const addressQ = buildingRes.alternate_addresses.join('" OR "');
    let q = `(alternate_addresses:("${addressQ}") AND (zip:${buildingRes.zip} OR borough:"${buildingRes.borough}"))`;
    let fq = [
      "price:[100000 TO 250000000] AND -property_type:(pa OR sr OR ps)",
      '-address_2_normalized:""',
      "status:sold AND source_namespace:WE3 AND transaction_source:(ACRIS-DOC OR ACRIS)",
      "parcels_condocoop_count:[1 TO 2]",
    ];

    if (_isHouse(buildingRes)) {
      fq = [
        "price:[100000 TO 250000000] AND -property_type:(pa OR sr OR ps)",
        "status:sold AND source_namespace:WE3 AND transaction_source:(ACRIS-DOC OR ACRIS)",
      ];
    }
    let axiosData = {
      url: apiURL + "/query/we3-transactions?cache=15",
      method: "post",
      query: {
        q: q,
        fq: fq,
        sort: null,
        wt: "json",
        fl: [
          "address_2_normalized",
          "discount*",
          "price",
          "close_date*",
          "verified_*",
          "lender",
        ],
        rows: 0,
        "json.facet": {
          sold_prices: {
            range: {
              field: "close_date_formatted",
              start: buildingRes.first_closing_date,
              end: "NOW+31DAY+1MONTH",
              gap: "+1YEAR",
              facet: {
                by_bedrooms: {
                  type: "terms",
                  field: "bedrooms",
                  facet: {
                    avg_price: "avg(price)",
                    median_price: "percentile(price,50)",
                  },
                },
                ppsf: {
                  type: "query",
                  q: "price_per_sqft:[500 TO 10000]",
                  facet: {
                    avg_ppsf: "avg(price_per_sqft)",
                  },
                },
              },
            },
          },
          min_price: "min(price)",
          max_price: "max(price)",
          avg_price: "avg(price)",
          median_price: "percentile(price,50)",
          sold_range: {
            type: "query",
            q: `price:[1 TO *] AND close_date_formatted:[NOW-${resaleTimePeriod}YEAR TO NOW]`,
            facet: {
              min_price: "min(price)",
              max_price: "max(price)",
              avg_price: "avg(price)",
              median_price: "percentile(price,50)",
            },
          },
          dom: {
            type: "query",
            q: `days_to_contract:[1 TO 9999] AND close_date_formatted:[NOW-${resaleTimePeriod}YEAR TO NOW]`,
            facet: {
              min_dom: "min(days_to_contract)",
              avg_dom: "avg(days_to_contract)",
              median_dom: "percentile(days_to_contract,50)",
              max_dom: "max(days_to_contract)",
            },
          },
          discount: {
            type: "query",
            q: `discount:[-30 TO 30] AND close_date_formatted:[NOW-${resaleTimePeriod}YEAR TO NOW]`,
            facet: {
              avg_discount: "avg(discount)",
            },
          },
          ppsf: {
            type: "query",
            q: `price_per_sqft:[200 TO 25000] AND ${
              buildingRes.building_status === "resale"
                ? "close_date_formatted:[NOW-" +
                  resaleTimePeriod +
                  "YEAR TO NOW]"
                : "sponsored_sale:true"
            } AND parcels_condocoop_count:1 AND property_type:(sc sp mc mp ck)`,
            facet: {
              min_ppsf: "min(price_per_sqft)",
              avg_ppsf: "avg(price_per_sqft)",
              max_ppsf: "max(price_per_sqft)",
              sum_sold_price: "sum(price)",
              sum_sq_ft: "sum(sq_ft)",
            },
          },
          pct_financed: {
            type: "query",
            q: `percent_financed:[1 TO 100] AND close_date_formatted:[NOW-${resaleTimePeriod}YEAR TO NOW]`,
            facet: {
              avg_pct: "avg(percent_financed)",
            },
          },
          count_no_finance: {
            type: "query",
            q: "*:*",
            facet: {
              no_finance: "avg(percent_financed)",
            },
          },
          price_changes: {
            type: "query",
            q: "*:*",
            facet: {
              avg_price_changes: "avg(num_price_changes)",
            },
          },
          has_bed: {
            type: "query",
            q: `bedrooms:[0 TO *] AND close_date_formatted:[NOW-${resaleTimePeriod}YEAR TO NOW]`,
            facet: {
              unit_mix: {
                type: "terms",
                field: "bedrooms",
                facet: {
                  avg_unit_size: "avg(sq_ft)",
                  med_unit_size: "percentile(sq_ft,0,50,100)",
                  non_zero_price: {
                    type: "query",
                    q: `price:[100 TO *] AND sq_ft:[100 TO *]`,
                    facet: {
                      avg_unit_size: "avg(sq_ft)",
                      med_unit_size: "percentile(sq_ft,25,50,75)",

                      avg_ppsf: `avg(div(price, sq_ft))`,
                      min_price: `min(price)`,
                      max_price: `max(price)`,
                    },
                  },
                },
              },
            },
          },
        },
      },
    };

    let formattedData = await _axiosCall(axiosData);
    return formattedData;
  };

  function extractBuildingStatData(statsRes, transactionalRes, isResale) {
    const validateNestedData = (data, path) => {
      return (
        path.split(".").reduce((acc, key) => acc && acc[key], data) !==
        undefined
      );
    };

    return [
      {
        name: "Avg Asking Price",
        price: isResale
          ? validateNestedData(statsRes, `facets.ppsf.avg_listed_price`)
            ? `${_formatPrice(statsRes.facets.ppsf.avg_listed_price)}`
            : "--"
          : validateNestedData(statsRes, `facets.non_zero_price.average_price`)
          ? `${_formatPrice(statsRes.facets.non_zero_price.average_price)}`
          : "--",
      },
      {
        name: "Avg Asking PPSF",
        price: isResale
          ? validateNestedData(statsRes, `facets.ppsf.avg_ppsf`)
            ? `$${_formatNumber(statsRes.facets.ppsf.avg_ppsf)}`
            : "--"
          : validateNestedData(statsRes, `facets.ppsf.sum_listed_price`) &&
            validateNestedData(statsRes, `facets.ppsf.sum_sq_ft`)
          ? `$${_formatNumber(
              statsRes.facets.ppsf.sum_listed_price /
                statsRes.facets.ppsf.sum_sq_ft
            )}`
          : "--",
      },
      {
        name: "Avg Sold Price",
        price: isResale
          ? validateNestedData(transactionalRes, `facets.sold_range.avg_price`)
            ? `${_formatPrice(transactionalRes.facets.sold_range.avg_price)}`
            : "--"
          : validateNestedData(transactionalRes, `facets.sold_range.avg_price`)
          ? `${_formatPrice(transactionalRes.facets.avg_price)}`
          : "--",
      },
      {
        name: "Avg Sold PPSF",
        price: isResale
          ? validateNestedData(transactionalRes, `facets.ppsf.avg_ppsf`)
            ? `$${_formatNumber(transactionalRes.facets.ppsf.avg_ppsf)}`
            : "--"
          : validateNestedData(
              transactionalRes,
              `facets.ppsf.sum_sold_price`
            ) && validateNestedData(transactionalRes, `facets.ppsf.sum_sq_ft`)
          ? `$${_formatNumber(
              transactionalRes.facets.ppsf.sum_sold_price /
                transactionalRes.facets.ppsf.sum_sq_ft
            )}`
          : "--",
      },
    ];
  }

  const handleAIGenerate = async (
    buildingRes,
    statsRes,
    activityRes,
    priceTrendRes,
    transactionalRes,
    listingRes
  ) => {
console.log(  buildingRes,
  statsRes,
  activityRes,
  priceTrendRes,
  transactionalRes,
  listingRes, "ListingRES")

    const isResale =
      ["pipeline", "sponsor"].indexOf(buildingRes.building_status) < 0;
    const buildingFieldMap = {
      name: { name: "Building Name", formatter: false },
      display_full_street_address: { name: "Address", formatter: false },
      neighborhood: { name: "Neighborhood", formatter: false },
      architect: { name: "Architect", formatter: false },
      total_floors: { name: "Total Floors", formatter: false },
      year_built: { name: "Year Built", formatter: false },
      developers: { name: "Developer", formatter: false },
      interior_designers: { name: "Interior Designer", formatter: false },
      // "manager" :  { name: "Property Mananger", formatter : false } ,
    };

    if (buildingRes["year_converted"] > buildingRes["year_built"]) {
      buildingFieldMap["year_converted"] = {
        name: "Year Converted",
        formatter: false,
      };
    }
    if (buildingRes["inventory_total"] && buildingRes["inventory_total"] > 1) {
      buildingFieldMap["inventory_total"] = {
        name: "Total Units",
        formatter: false,
      };
    } else if (
      buildingRes["total_units_residential"] &&
      buildingRes["total_units_residential"] > 1
    ) {
      buildingFieldMap["total_units_residential"] = {
        name: "Total Units",
        formatter: false,
      };
    } else if (buildingRes["total_units"] && buildingRes["total_units"] > 1) {
      buildingFieldMap["total_units"] = {
        name: "Total Units",
        formatter: false,
      };
    }

    let promptData = [];

    Object.keys(buildingRes).map((key) => {
      if (buildingFieldMap[key]) {
        const val =
          Array.isArray(buildingRes[key]) && buildingRes[key][0]
            ? buildingRes[key][0]
            : buildingRes[key];
        if (val && _shouldShow(val)) {
          promptData.push(
            `${buildingFieldMap[key].name}=${
              buildingFieldMap[key].formatter
                ? buildingFieldMap[key].formatter(val)
                : val
            }`
          );
        }
      }
    });
    const compiledFeatureList = _getFeaturesArr("building", false, buildingRes);
    const highlightedAmenities = amenitiesList
      .filter((item) =>
        compiledFeatureList.some((el) => item.values.includes(el))
      )
      .map((el) => el.name);

    promptData.push(`Building Amenities=${highlightedAmenities.join(", ")}`);

    if (
      formValues &&
      formValues["highlights"] &&
      formValues["highlights"].length > 0
    ) {
      promptData.push(
        `Key Unit Features=${formValues["highlights"].join(", ")}`
      );
    }

    let prompt = `Write a building_summary (Store in JSON Response: building_summary) tone in a professional but friendly tone, around 300 words.  Be more factual rather than salesy.`;
    //prompt += " Don’t justify your answers. Don’t give information not mentioned in the Marketproof Data.";
    prompt +=
      " Don’t justify your answers.  Don't project too much.  Prioritize and use all the information provided in the Marketproof Data.  \n\nIf a Listing Description is available, extract  building level amentiies and neighborhood features, ignore everything unit level and use to add additional color to the summary.  DO NOT mention the unit features.";

    if (buildingRes["building_status"] == "sponsor") {
      // if (moment(buildingRes["building_effective_start"]).year() > 1970 || moment(buildingRes["first_closing_date"]).year() > 1970) {
      //    prompt += ` Add to the response: "Immediate closings."`;
      //
      //  }
      prompt +=
        " If the listing description has unit level finishes such as brand of applicances and is likely applicable to all units in the building, you can use that to add color as well.";
      if (buildingRes["inventory_pct_unsold"]) {
        if (
          buildingRes["inventory_pct_unsold"] < 50 &&
          buildingRes["inventory_pct_unsold"] > 15
        ) {
          prompt += ` Add to the response: "Over 50% sold."`;
        }
      }
    }

    if (listingRes && listingRes.docs && listingRes.docs[0]) {
      promptData.push(`Listing Description=${listingRes.docs[0].description}`);
    }

    promptData.push(
      `Building Stats=${JSON.stringify(
        extractBuildingStatData(statsRes, transactionalRes, isResale)
      )}`
    );
    promptData.push(
      `Neighborhood Contract Activity=${JSON.stringify({
        current_period: activityRes.facets.contract_signed.current_period,
        prior_period: activityRes.facets.contract_signed.prior_year_period,
      })}`
    );
    promptData.push(
      `Neighborhood Price Trend=${JSON.stringify(priceTrendRes)}`
    );

    prompt += `\n\n Then write a 100 word building analysis (Store in JSON Response: building_analysis) using data from "Building Stats", speak specifically to the buildings average asking price and sold price and unit mix, and nothing else.   Average asking price can be found in facets.non_zero_price.average_price, average sold pirce is found in facets.sold_range.avg_price.  If the building_status is resale, the prices reflects only the last 24 months and should be stated as such.   If only some of the data is available, just analyze that portion, do not speak to lack of data makes it hard to analyze. If no info is available for all data points, simply state no inforamtion is available to analyze this building at this time.  Do not be any more specific than that, if no data or incomplete data then analysis could be fewer than 100 words. `;

    prompt += `\n\n Then write a 100 word neighborhood contract activity analysis (Store in JSON Response: neighborhood_contract_analysis) using data from "Neighborhood Contract Activity", speak specifically to the number of contracts across new devs, condosand coops this period compared to previous period, and nothing else.`;

    prompt += `\n\n Then write a 100 word neighborhood price trend analysis (Store in JSON Response: neighborhood_price_analysis) using data from "Neighborhood Price Trend", the data contains arrays by time unit sold.  Do not name the period, just say current period.  Highlight the last period (last element in each array) and  speak specifically to the Avg PPSF price trend across new devs, condosand coops, and how it compared to the building's price.  The PPSF should not be combined, each property type's ppsf is unique.  Compare the PPSF of the same property type as the building.   `;

    // const avgBuildingPrice = isResale
    // ? validateNestedData(statsRes, `facets.non_zero_price.average_price`)
    //   ? `${_formatPrice(statsRes.facets.non_zero_price.average_price)}`
    //   : "--"
    // : validateNestedData(statsRes, `facets.non_zero_price.average_price`)
    //   ? `${_formatPrice(
    //       statsRes.facets.non_zero_price.average_price
    //     )}`
    //   : ""
    // const avgBuildingPPSF = isResale
    // ? validateNestedData(statsRes, `facets.ppsf.avg_ppsf`)
    //   ? `$${_formatNumber(statsRes.facets.ppsf.avg_ppsf)}`
    //   : "--"
    // : validateNestedData(statsRes, `facets.ppsf.sum_listed_price`) &&
    //   validateNestedData(statsRes, `facets.ppsf.sum_sq_ft`)
    //   ? `$${_formatNumber(
    //       statsRes.facets.ppsf.sum_listed_price /
    //       statsRes.facets.ppsf.sum_sq_ft
    //     )}`
    //   : "--"

    let systemContent = `You are a real estate analyst, use the following Marketproof Data about a building.  Abbreviate long currency so it's $1.5M, round if less than $1M.  If less than $1M use K.  No deimcals for prices.  Number should be in format ###,###,###.  For analysis, be concise with the anlaysis and over project if not be based on the data.  \n\n${promptData.join(
      "\n"
    )}`;

    // if(listing && listing.description){
    //    systemContent += "\n\nExtract only unit appliances, finishes and building amenities from the following for text but always prioritize Marketproof Data when available.  Don’t justify your answers.";
    //    systemContent += "\n\n";
    //    systemContent += `"${listing.description}"`;
    //  }else if(buildingListing && buildingListing.description){
    //    systemContent += "\n\nExtract only unit appliances (ignore any that indicates renovation), finishes and building amenities from the following for text but always prioritize Marketproof Data when available.  Don’t justify your answers.";
    //     systemContent += "\n\n";
    //     systemContent += `"${buildingListing.description}"`;
    //  }

    prompt += ` The results should be in valid raw JSON format, no formatting.  { "building_summary" :  "summary in text", "building_analysis": "analysis in text", "neighborhood_contract_analysis" : "analysis in text", "neighborhood_price_analysis" : "analysis in text" } }`;

    const queryData = {
      messages: [
        {
          role: "system",
          content: systemContent,
        },
        { role: "user", content: prompt },
      ],
      model: "gpt-4o",
      response_format: { type: "json_object" },
    };

    const axiosData = {
      url: apiURL + "/ai/chat",
      method: "post",
      query: queryData,
    };
    let aiResponse = {};
    try {
      const res = await _axiosCall(axiosData);
      console.log(res);

      if (
        res &&
        res.choices &&
        res.choices[0] &&
        res.choices[0].message &&
        res.choices[0].message.content
      ) {
        const result = res.choices[0].message.content;

        try {
          aiResponse = JSON.parse(result);
          console.log(aiResponse);
        } catch (e) {}
      }
    } catch (error) {
      console.log("Error generating summary:", error);
    }
    return aiResponse;
  };
  if (!reportData) return null;

  const buildingRes = reportData.buildingRes.building[0];

  {
    console.log(reportData, "reportData");
  }

  const calculateInventorySold = (buildingRes) => {
    let totalSold =
      buildingRes.inventory_sold +
      buildingRes.inventory_resale +
      buildingRes.inventory_not_yet_recorded +
      buildingRes.inventory_contract;

    if (
      buildingRes.inventory_bulk_sold &&
      buildingRes.inventory_bulk_sold > 0
    ) {
      totalSold += buildingRes.inventory_bulk_sold;
    }

    const percentSold = Math.floor(
      (totalSold / buildingRes.inventory_total) * 100
    );
    return {
      totalSold,
      percentSold: percentSold,
      inventory: buildingRes.inventory_total,
    };
  };
  let calculateInventorySoldData = calculateInventorySold(buildingRes);

  const getAmenities = () => {
    const compiledFeatureList = _getFeaturesArr(
      "building",
      _isHouse(buildingRes),
      buildingRes
    );
    const highlightedAmenities = amenitiesList.filter((item) =>
      compiledFeatureList.some((el) => item.values.includes(el))
    );
    const buildingAmenitiesFiltered = compiledFeatureList.filter(
      (item) => !amenitiesList.some((el) => el.values.includes(item))
    );
    const rowCount =
      highlightedAmenities && highlightedAmenities.length > 0
        ? highlightedAmenities.length < 5
          ? highlightedAmenities.length
          : highlightedAmenities.length < 9
          ? Math.ceil(highlightedAmenities.length / 3)
          : 4
        : false;

    const rows = rowCount ? _chunkArray(highlightedAmenities, rowCount) : false;

    let otherAmenities =
      buildingRes &&
      _shouldShow(buildingRes.amenities_other) &&
      Array.isArray(buildingRes.amenities_other)
        ? buildingRes.amenities_other.filter(
            (item) => !userEditFieldsObj.filterOtherAmenities.includes(item)
          )
        : false;
    const mainFeatures = buildingAmenitiesFiltered.map((feature) =>
      feature.replace(/[^a-zA-Z0-9]/g, " ")
    );
    console.log(mainFeatures);
    const featuresLen =
      mainFeatures && mainFeatures.length > 0
        ? otherAmenities && otherAmenities.length > 0
          ? mainFeatures.length + otherAmenities.length
          : mainFeatures.length
        : otherAmenities && otherAmenities.length > 0
        ? otherAmenities.length
        : 0;

    const amenitiesLenGreaterThanTwo =
      featuresLen > 1 ||
      (highlightedAmenities && highlightedAmenities.length > 1) ||
      featuresLen + highlightedAmenities.length > 1;
    return {
      highlightedAmenities: !amenitiesLenGreaterThanTwo
        ? [{ name: "", icon: null }]
        : highlightedAmenities,
      mainFeatures: mainFeatures.length
        ? mainFeatures.map((content) => ({
            name: content,
            icon: <FeatureIcon />,
          }))
        : [{ name: "", icon: null }],
      otherAmenities: otherAmenities.length
        ? otherAmenities.map((content) => ({
            name: content,
            icon: <FeatureIcon />,
          }))
        : [{ name: "", icon: null }],
    };
  };

  const generateUnitMixData = (isResale) => {
    const statsRes = isResale
      ? reportData.transactionalRes.facets
      : reportData.statsRes.facets;

    if (
      !statsRes ||
      !statsRes.has_bed ||
      !statsRes.has_bed.unit_mix ||
      !statsRes.has_bed.unit_mix.buckets
    ) {
      return [];
    }

    const data = [
      { name: "Studio", count: 0, avgPpsf: 0 },
      { name: "1 Bed", count: 0, avgPpsf: 0 },
      { name: "2 Bed", count: 0, avgPpsf: 0 },
      { name: "3 Bed", count: 0, avgPpsf: 0 },
      { name: "4+ Bed", count: 0, avgPpsf: 0 },
    ];

    statsRes.has_bed.unit_mix.buckets.forEach((bucket) => {
      const index = bucket.val >= 0 && bucket.val < 4 ? bucket.val : 4;
      const currentCategory = data[index];

      currentCategory.count += bucket.count;
      currentCategory.avgPpsf = bucket.non_zero_price.avg_ppsf || 0;
    });

    return data.filter((item) => item.count || item.avgPpsf);
  };

  const genrateLabel = () => {
    if (gap === "+1MONTH") return "Month-over-Month";
    else if (gap === "+7DAY") return "Week-over-Week";
    else return "Quarter-over-Quarter";
  };
  function findOneYearBack(data, currentObj) {
    if (!Array.isArray(data)) return null;
    const currentDate = new Date(currentObj.value);
    if (isNaN(currentDate)) return null;
    const oneYearBackDate = new Date(currentDate);
    oneYearBackDate.setFullYear(oneYearBackDate.getFullYear() - 1);
    const oneYearBackObj = data.find((obj) => {
      const objDate = new Date(obj.value);
      return objDate.getTime() === oneYearBackDate.getTime();
    });

    return oneYearBackObj || null;
  }
  const priceTrendOneYearBack = findOneYearBack(
    reportData.priceTrendRes,
    reportData.priceTrendRes[reportData.priceTrendRes.length - 1]
  );
  const isResale =
    ["pipeline", "sponsor"].indexOf(buildingRes.building_status) < 0;
  let images = _getBuildingPhotos(buildingRes);
  images = images.filter((image) => image != "-1");
  let isOldCoop =
    _isCoop(buildingRes) &&
    buildingRes.year_built <= 2000 &&
    buildingRes.year_converted <= 2000;
  let lowPrice = isResale
    ? validateNestedData(buildingRes, `inventory_stats_transactions_low_price`)
      ? buildingRes.inventory_stats_transactions_low_price
      : 0
    : buildingRes.inventory_stats_listings_low_price;
  let highPrice = isResale
    ? validateNestedData(buildingRes, `inventory_stats_transactions_high_price`)
      ? buildingRes.inventory_stats_transactions_high_price
      : 0
    : buildingRes.inventory_stats_listings_high_price;
  let buildingOwnershipType =
    buildingRes.ownership_type && _shouldShow(buildingRes.ownership_type)
      ? buildingRes.ownership_type.toString().toLowerCase().trim()
      : false;
  const buildingAltAdr = _checkBuildingAltAdr(buildingRes);
  const buildingNameOrAdr = buildingRes.name
    ? _capitalizeText(buildingRes.name)
    : buildingRes.display_full_street_address
    ? _capitalizeText(buildingRes.display_full_street_address)
    : _capitalizeText(buildingRes.full_street_address);
  const BottomContent = () => {
    return (
      <div className="bottom-content">
        {/* <>
          {buildingRes.cdec_date &&
          parseInt(moment(buildingRes.cdec_date).format("YYYY")) >
            1970 &&
          buildingRes.building_status !== "resale" ? (
            <div className="first-ele">
              <span>Sales Progress:</span>
              <span>{`${calculateInventorySoldData.totalSold} out of ${calculateInventorySoldData.inventory} units sold (${calculateInventorySoldData.percentSold}%) `}</span>
            </div>
          ) : null}
        </> */}
        {[
          !isResale
            ? {
                "Sales Progress":
                  calculateInventorySoldData &&
                  calculateInventorySoldData.totalSold !== undefined &&
                  calculateInventorySoldData.inventory !== undefined &&
                  calculateInventorySoldData.percentSold !== undefined
                    ? `${calculateInventorySoldData.totalSold} out of ${calculateInventorySoldData.inventory} units sold (${calculateInventorySoldData.percentSold}%)`
                    : "--",
              }
            : null,
          {
            "Building Type":
              buildingOwnershipType !== undefined &&
              buildingOwnershipType !== null
                ? _capitalizeText(buildingOwnershipType)
                : "--",
          },
          {
            "Building Stage":
              buildingRes && buildingRes.building_status !== undefined
                ? _capitalizeText(buildingRes.building_status)
                : "--",
          },
          !isResale || (buildingRes && buildingRes.sales_start_date && parseInt(
              moment(buildingRes.sales_start_date).format("YYYY")
            ) > 1990) ? {
            "Sales Started":
              buildingRes && buildingRes.sales_start_date
                ? `${
                    parseInt(
                      moment(buildingRes.sales_start_date).format("YYYY")
                    ) > 1990
                      ? `${_capitalizeText(
                          moment(buildingRes.sales_start_date).fromNow()
                        )} (${_capitalizeText(
                          moment(buildingRes.sales_start_date).format(
                            "MM/DD/YYYY"
                          )
                        )})`
                      : !isResale
                      ? "Not Started"
                      : "--"
                  }`
                : "--",
          } : null,
          {
            "Closings Started":
              buildingRes && buildingRes.first_closing_date
                ? `${
                    parseInt(
                      moment(buildingRes.first_closing_date).format("YYYY")
                    ) > 1990
                      ? `${_capitalizeText(
                          moment(buildingRes.first_closing_date).fromNow()
                        )} (${_capitalizeText(
                          moment(buildingRes.first_closing_date).format(
                            "MM/DD/YYYY"
                          )
                        )})`
                      : !isResale
                      ? "Not Started"
                      : "--"
                  }`
                : "--",
          },
          {
            "Offering Type":
              buildingRes && buildingRes.offering_construction
                ? `${
                    buildingRes.offering_construction === "new"
                      ? "New Construction"
                      : _capitalizeText(buildingRes.offering_construction)
                  } ${_capitalizeText(buildingRes.offering_plan_type || "--")}`
                : "--",
          },
          !isResale
            ? {
                "Sales Agent":
                  buildingRes &&
                  (buildingRes.marketing_company || buildingRes.sales_office)
                    ? buildingRes.marketing_company || buildingRes.sales_office
                    : "--",
              }
            : null,
          {
            Developer:
              buildingRes && buildingRes.developers !== undefined
                ? `${buildingRes.developers}`
                : "--",
          },
          {
            Architect:
              buildingRes && buildingRes.architect !== undefined
                ? buildingRes.building_status === "resale"
                  ? _capitalizeText(buildingRes.architect)
                  : buildingRes.architect
                : "--",
          },
          {
            "Landscape Design":
              buildingRes && buildingRes.landscape_architect
                ? buildingRes.landscape_architect
                : "--",
            "Interior Designer":
              buildingRes && buildingRes.interior_designers
                ? buildingRes.interior_designers
                : "--",
          },
          !isResale ?
          {
            "Certificate of Occupancy":
              buildingRes && buildingRes.building_effective_start
                ? `${
                    parseInt(
                      moment(buildingRes.building_effective_start).format(
                        "YYYY"
                      )
                    ) > 1970
                      ? `${_capitalizeText(
                          moment(buildingRes.building_effective_start).fromNow()
                        )} (${_capitalizeText(
                          moment(buildingRes.building_effective_start).format(
                            "MM/DD/YYYY"
                          )
                        )})`
                      : _shouldShow(buildingRes.year_converted)
                      ? "--"
                      : "Not Issued"
                  }`
                : "--",
          } : null,
        ]
          .filter((content) => {
            if (!content) return false;
            const [[, value]] = Object.entries(content);
            return value !== null && value !== undefined && value !== "";
          })
          .map((content, index) => {
            const [[key, value]] = Object.entries(content);
            return (
              <div key={index}>
                <span>{key}:</span>
                <span>{value}</span>
              </div>
            );
          })}
      </div>
    );
  };
  const BottomContentOldCoop = () => {
    return (
      <div className="bottom-content">
        {[
          {
            "Building Type":
              buildingOwnershipType !== undefined
                ? _capitalizeText(buildingOwnershipType)
                : "--",
          },
          {
            "Building Stage":
              buildingRes && buildingRes.building_status !== undefined
                ? _capitalizeText(buildingRes.building_status)
                : "--",
          },
          {
            "Historic District":
              buildingRes && buildingRes.historic_district !== undefined
                ? _capitalizeText(buildingRes.historic_district)
                : "Not in Historic District",
          },
          {
            "Block & Lot":
              buildingRes && buildingRes.block !== undefined
                ? `${buildingRes.block} | ${buildingRes.lot}`
                : "--",
          },
          {
            "Year Built":
              buildingRes && buildingRes.year_built !== undefined
                ? buildingRes.year_built
                : "--",
          },
          buildingRes &&
          buildingRes.year_converted !== undefined &&
          buildingRes.year_converted > 1900
            ? {
                "Year Converted": buildingRes.year_converted,
              }
            : null,
          {
            Access:
              buildingRes &&
              buildingRes.building_access &&
              buildingRes.building_access[0] !== undefined
                ? _capitalizeText(
                    buildingRes.building_access[0].replace(/_/g, " ")
                  )
                : "--",
          },
          {
            "Service Level":
              buildingRes && buildingRes.building_service_level !== undefined
                ? _capitalizeText(
                    _getServiceLevel(buildingRes.building_service_level)
                  )
                : "--",
          },
          {
            "Floor Area":
              buildingRes && buildingRes.sq_ft !== undefined
                ? _formatNum(buildingRes.sq_ft) + " sqft"
                : "--",
          },
          {
            "Lot Size":
              buildingRes && buildingRes.lot_area !== undefined
                ? _formatNum(buildingRes.lot_area) + " sqft"
                : "--",
          },
          buildingAltAdr !== undefined
            ? {
                "Alternate Addresses": Array.isArray(buildingAltAdr)
                  ? buildingAltAdr.join(", ")
                  : buildingAltAdr,
              }
            : null,
        ]
          .filter((content) => {
            if (!content) return false;
            const [[, value]] = Object.entries(content);
            return value !== null && value !== undefined && value !== "";
          })
          .map((content, index) => {
            const [[key, value]] = Object.entries(content);
            return (
              <div key={index}>
                <span>{key}:</span>
                <span>{value}</span>
              </div>
            );
          })}
      </div>
    );
  };
  const processChartData = (priceTrendRes) => {
    const categories = ["NewDev", "Condo", "Coop"];
    const zeroCounts = { NewDev: 0, Condo: 0, Coop: 0 };
    const totalEntries = priceTrendRes.length;

    // Initialize last valid values with placeholders
    const lastValidPPSF = Object.fromEntries(
      categories.map((category) => [category, null])
    );

    // First pass: Pre-fill initial valid values
    categories.forEach((category) => {
      for (const data of priceTrendRes) {
        const avgPPSF = Math.ceil(data[category.toLowerCase()].avg_ppsf || 0);
        if (avgPPSF > 0) {
          lastValidPPSF[category] = avgPPSF;
          break; // Stop once we find the first valid value
        }
      }
    });

    // Second pass: Process the data
    const processedData = priceTrendRes.map((data) => {
      const result = {
        date: formatDateRange(null, null, data.value),
      };

      categories.forEach((category) => {
        const avgPPSF = Math.ceil(data[category.toLowerCase()].avg_ppsf || 0);

        if (avgPPSF > 0) {
          lastValidPPSF[category] = avgPPSF;
        } else {
          zeroCounts[category]++;
        }

        result[category] = lastValidPPSF[category];
      });

      return result;
    });

    // Filter out categories with more than 50% invalid values
    categories.forEach((category) => {
      if (zeroCounts[category] > totalEntries / 2) {
        processedData.forEach((entry) => {
          delete entry[category];
        });
      }
    });

    return processedData;
  };

  // Pass `data` to your component
  console.log(AiResponse, "aiResponse");
  console.log(reportData, 'reportData');
  const reportDate = moment().format('MMMM Do, YYYY');
  return (
    <>
    <CoverPage
      {...props}
      summarizeGeographies={summarizeGeographies} 
      priorYearPeriodName={priorYearPeriodName} 
      currentPeriodName={currentPeriodName}
      dateDisplay={reportDate}
      defaultImage={images[0] ? images[0] : false}
     />
    <div className="report-container page-section">
      <h3 className="editable building-location">
        {_capitalizeText(buildingNameOrAdr)}
      </h3> 
      <h3 className="header-text heading-location editable">{`${_capitalizeText(buildingRes.neighborhood)}, ${_capitalizeText(buildingRes.borough)}`.toUpperCase()}</h3>
      <div className="header-report-date editable">Report Date: {reportDate}</div>
      <section className="report-section" style={{minHeight:1150}}>
        <div class="building-view-content-wrapper">
          <div class="image-section" style={{backgroundImage:`url(${images[0]})`}}>
            {/*<img src={images[0]} alt="Building" />*/}
          </div>
          <div>
            <div className="top-content">
              {[
                { Floors: buildingRes.total_floors && buildingRes.total_floors > 0 ? buildingRes.total_floors : "--" },
                { Units: buildingRes.inventory_total && buildingRes.inventory_total > 0 ? buildingRes.inventory_total : "--" },
                { [buildingRes.year_converted && buildingRes.year_converted >  buildingRes.year_built  ? "Year Converted" : "Year Built"]: buildingRes.year_converted && buildingRes.year_converted >  buildingRes.year_built  ?  buildingRes.year_converted : buildingRes.year_built },
                {
                  [
                    buildingRes.building_status === "resale"
                      ? isOldCoop ? "Sold Last 24-Months" : "Sold Price Range"
                      : "Asking Price Range"
                  ]: (lowPrice && lowPrice > 100) ? `${_formatPrice(lowPrice)} - ${_formatPrice(highPrice)}` : "--",
                }
                
              ].map((content, index) => {
                const [[key, value]] = Object.entries(content);
                return (
                  <div key={index} className="inner-building-view-top-nav">
                    <span>{value}</span>
                    <span>{key}</span>
                  </div>
                );
              })}
            </div>
            {isOldCoop ? 
              <BottomContentOldCoop />
              :
              <BottomContent />
            }
            
          </div>
        </div>
        <div className="building-view-summary-container">
          <h3 className="building-view-header editable">Summary</h3>
          <p className="building-view-summary-text editable">
           {AiResponse && AiResponse.building_summary ? AiResponse.building_summary : <CustomSkeleton count={16}/>}
            
            
          </p>
        </div>
        <h3 className="building-view-header editable">Amenities</h3>
        {(getAmenities().mainFeatures.length || getAmenities().otherAmenities.length > 0) ? 
          <>
            <Amenities data={getAmenities().highlightedAmenities} />
            <Amenities
              data={[
                ...getAmenities().mainFeatures,
                ...getAmenities().otherAmenities,
              ]}
              isAdditional={true}
            />
          </>:<div className="building-view-no-info"><hr/><p>No amenities info available</p></div>}
          
        
       
      </section>
      <Footer />
    </div>
    <div className="report-container page-section">
      <h3 className="editable building-location">  {buildingNameOrAdr}</h3>
      <h3 className="header-text heading-location editable">
        BUILDING ANALYSIS
      </h3>
      <section className="report-section">
        <div className="card-main-container">
          {" "}
          <h3 className="building-view-header editable">
            Pricing Overview {isResale ? "(24-Months)" : null}
          </h3>
          <hr/>
          <div className="report-cards-container">
          <Cards
                  name="Avg Asking Price"
                  price={
                    isResale
                      ? validateNestedData(reportData, `statsRes.facets.ppsf.avg_listed_price`)
                        ? `${_formatPrice(reportData.statsRes.facets.ppsf.avg_listed_price)}`
                        : "--"
                      : validateNestedData(reportData, `statsRes.facets.non_zero_price.average_price`) 
                        ? `${_formatPrice(
                            reportData.statsRes.facets.non_zero_price.average_price
                          )}`
                        : "--"
                  }
                />
                <Cards
                  name="Avg Asking PPSF"
                  price={
                    isResale
                      ? validateNestedData(reportData, `statsRes.facets.ppsf.avg_ppsf`)
                        ? `$${_formatNumber(reportData.statsRes.facets.ppsf.avg_ppsf)}`
                        : "--"
                      : validateNestedData(reportData, `statsRes.facets.ppsf.sum_listed_price`) &&
                        validateNestedData(reportData, `statsRes.facets.ppsf.sum_sq_ft`)
                        ? `$${_formatNumber(
                            reportData.statsRes.facets.ppsf.sum_listed_price /
                            reportData.statsRes.facets.ppsf.sum_sq_ft
                          )}`
                        : "--"
                  }
                />
                  <Cards name="Avg Sold Price" price={ isResale
                    ? validateNestedData(reportData, `transactionalRes.facets.sold_range.avg_price`)
                      ? `${_formatPrice(reportData.transactionalRes.facets.sold_range.avg_price)}`
                      : "--" 
                      : validateNestedData(reportData, `transactionalRes.facets.sold_range.avg_price`) &&
                  validateNestedData(reportData, `transactionalRes.facets.sold_range.avg_price`)
          ? `${_formatPrice(
                      reportData.transactionalRes.facets.avg_price
                    )}`
          : "--"} />
          
            <Cards name="Avg Sold PPSF" price={ isResale
              ? validateNestedData(reportData, `transactionalRes.facets.ppsf.avg_ppsf`)
                ? `$${_formatNumber(reportData.transactionalRes.facets.ppsf.avg_ppsf)}`
                : "--"
                : validateNestedData(reportData, `transactionalRes.facets.ppsf.sum_sold_price`) &&
            validateNestedData(reportData, `transactionalRes.facets.ppsf.sum_sq_ft`)
    ? `$${_formatNumber(
                reportData.transactionalRes.facets.ppsf.sum_sold_price / reportData.transactionalRes.facets.ppsf.sum_sq_ft
              )}`
    : "--"} />
            
          </div>
        </div>
        <div className="building-view-summary-container">
          <p className="building-view-summary-text editable">
            {AiResponse && AiResponse.building_analysis ? AiResponse.building_analysis : <CustomSkeleton count={16}/>}
            
          </p>
        </div>

        {buildingRes.cdec_date &&
        parseInt(moment(buildingRes.cdec_date).format("YYYY")) > 1970 &&
        !isResale ? (
          <>
            {" "}
            <h3 className="building-view-header editable">
              Sales Progress
            </h3>
            <div className="bar_component">
              <Bar
                content={`${calculateInventorySoldData.totalSold} out of ${calculateInventorySoldData.inventory} units sold (${calculateInventorySoldData.percentSold}%)`}
                percent={calculateInventorySoldData.percentSold}
              />
            </div>
          </>
        ) : null}

        {isOldCoop ? 
          
          <div className="building-charts-container">
            <div>
            <h3 className="building-view-header editable">
              # of Sales (24-Months)
            </h3>
            {generateUnitMixData(true).length > 0 ?
            <CustomBarChart
              data={generateUnitMixData(true).map((item) => ({
                ...item,
                value: !item.count ? null : item.count
              }))}
              noSpecialCharacter={true}
              theme={theme}
            /> : <div className="building-view-no-info"><hr/><p>No sales info available</p></div>}
            </div>
            <div>
            <h3 className="building-view-header editable">
             Sold PPSF (24-Months)
            </h3>
            {generateUnitMixData(true).filter(item => item.avgPpsf && item.avgPpsf > 100).length>0 ? 
            <CustomBarChart
              data={generateUnitMixData(true).filter(item => item.avgPpsf && item.avgPpsf > 100).map((item) => ({
                ...item,
                value: Math.round(item.avgPpsf)
              }))}
              noSpecialCharacter={true}
              theme={theme}
              isPrice={true}
          
            /> : <div className="building-view-no-info"><hr/><p>No pricing info available</p></div>}
            </div>
          </div>
          
          : isResale ? 
          <div className="building-charts-container">
            <div>
            <h3 className="building-view-header editable">
              Unit Mix
            </h3>
            {generateUnitMixData().length > 0 ?
            <CustomBarChart
              data={generateUnitMixData().map((item) => ({
                ...item,
                value: !item.count ? null : item.count
              }))}
              noSpecialCharacter={true}
              theme={theme}
            /> : <div className="building-view-no-info"><hr/><p>No unit mix info available</p></div>}
            </div>
            <div>
            <h3 className="building-view-header editable">
             Sold PPSF (24-Months)
            </h3>
            {generateUnitMixData(true).filter(item => item.avgPpsf && item.avgPpsf > 100).length>0 ? 
            <CustomBarChart
              data={generateUnitMixData(true).filter(item => item.avgPpsf && item.avgPpsf > 100).map((item) => ({
                ...item,
                value: Math.round(item.avgPpsf)
              }))}
              noSpecialCharacter={true}
              theme={theme}
              isPrice={true}

            /> : <div className="building-view-no-info"><hr/><p>No pricing info available</p></div>}
            </div>
          </div>
          :
          <div className="building-charts-container">
            <div>
            <h3 className="building-view-header editable">
              Unit Mix
            </h3>
            {generateUnitMixData().length > 0 ?
            <CustomBarChart
              data={generateUnitMixData().map((item) => ({
                ...item,
                value: !item.count ? null : item.count
              }))}
              noSpecialCharacter={true}
              theme={theme}
            /> : <div className="building-view-no-info"><hr/><p>No unit mix info available</p></div>}
            </div>
            <div>
            <h3 className="building-view-header editable">
               Asking PPSF
            </h3>
            {generateUnitMixData().filter(item => item.avgPpsf && item.avgPpsf > 100).length>0 ?
            <CustomBarChart
              data={generateUnitMixData().filter(item => item.avgPpsf && item.avgPpsf > 100).map((item) => ({
                ...item,
                value: Math.round(item.avgPpsf)
              }))}
              noSpecialCharacter={true}
              isPrice={true}
              theme={theme}
            /> : <div className="building-view-no-info"><hr/><p>No pricing info available</p></div>}
            </div>
          </div>
          
        }
        
        <div className="table-component-building-view">
          <h3 className="building-view-header editable">
            Recent Sales in This Building
          </h3>
          <div className="report-layout-table-container">
          {reportData.tableRes &&  reportData.tableRes &&reportData.tableRes.length>0 ? 
            <CustomTable
              headers={[
                "DATE",
                "UNIT",
                "BED/BATH",
                "SQ FT",
                "SOLD PRICE",
                "SOLD PPSF",
              ]}
              rows={reportData.tableRes.slice(0, (isResale ? 10 : 5)).map((item) => [
                item.close_date_formatted !== -1
                  ? formatDate(item.close_date_formatted)
                  : "--",
                item.address_2_normalized !== -1
                  ? item.address_2_normalized.toUpperCase()
                  : "--",
                item.bedrooms !== -1 && item.baths !== -1
                  ? `${item.bedrooms} / ${item.baths}`
                  : "--",
                item.sq_ft !== -1
                  ? `${_formatNumber(item.sq_ft)} Sq ft`
                  : "--",
                item.price !== -1 ? `$${_formatNumber(item.price)}` : "--",
                item.price_per_sqft !== -1
                  ? `$${_formatNumber(item.price_per_sqft)}`
                  : "--",
              ])}
              theme={theme}
              color={color}
            />
            : <div className="building-view-no-info"><hr/><p>No closings in this buiding</p></div>
          }
          </div>
        </div>
      </section>
      <Footer />
    </div>
    <div className="report-container page-section neighborhood">
      <h3 className="editable building-location">{reportData.buildingRes.building[0].neighborhood[0].toUpperCase()}</h3>
      <h3 className="header-text heading-location editable">
        NEIGHBORHOOD ANALYSIS
      </h3>
      <section className="report-section">
        <div className="card-main-container">
          <h3 className="building-view-header editable">Contracts</h3>
          <div className="building-view-text-wrapper">
            <div className="building-view-text">
              {` Sales Contract Activity in ${reportData.buildingRes.building[0].neighborhood[0]}`}
            </div>
            <div>{`/ ${currentPeriodName}`}</div>
          </div>
          <div className="report-cards-container">
          <Cards
name="NEW DEV"
price={
  validateNestedData(reportData, `activityRes.facets.contract_signed.current_period.newdev.count`)
    ? reportData.activityRes.facets.contract_signed.current_period.newdev.count
    : "--"
}
subContent1={`${
  (reportData.activityRes &&reportData.activityRes.facets && reportData.activityRes.facets.contract_signed && reportData.activityRes.facets.contract_signed.by_time && reportData.activityRes.facets.contract_signed.by_time.buckets && reportData.activityRes.facets.contract_signed.by_time.buckets.length && reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-1] && reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-1].newdev)  &&
  (reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-2]) && reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-2].newdev
    ? `${percentageChange(
        reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-1].newdev.count,
        reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-2].newdev.count
      )}%`
    : "0"
} ${genrateLabel()}`}
subContent2={`${
  validateNestedData(reportData, "activityRes.facets.contract_signed.current_period.newdev.count") &&
  validateNestedData(reportData, "activityRes.facets.contract_signed.prior_year_period.newdev.count")
    ? `${percentageChange(
        reportData.activityRes.facets.contract_signed.current_period.newdev.count,
        reportData.activityRes.facets.contract_signed.prior_year_period.newdev.count
      )}%`
    : "0"
} Year-over-Year`}
/>

            <Cards
              name="CONDO"
              price={validateNestedData(reportData, `activityRes.facets.contract_signed.current_period.resale_condo.count`)? reportData.activityRes.facets.contract_signed.current_period.resale_condo.count:"--" }
              subContent1={`${
                (reportData.activityRes && reportData.activityRes.facets&& reportData.activityRes.facets.contract_signed && reportData.activityRes.facets.contract_signed.by_time && reportData.activityRes.facets.contract_signed.by_time.buckets && reportData.activityRes.facets.contract_signed.by_time.buckets.length && reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-1]) && reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-1].resale_condo &&
                (reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-2] && reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-2].resale_condo)
                  ? `${percentageChange(
                      reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-1].resale_condo.count,
                      reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-2].resale_condo.count
                    )}%`
                  : "0"
              } ${genrateLabel()}`}
              subContent2={`${
             reportData.activityRes.facets.contract_signed &&   reportData.activityRes.facets.contract_signed.current_period && reportData.activityRes.facets.contract_signed &&   reportData.activityRes.facets.contract_signed.prior_year_period &&  validateNestedData(reportData, "activityRes.contract_signed.current_period.resale_condo.count") &&
                validateNestedData(reportData, "activityRes.contract_signed.prior_year_period.resale_condo.count")
                  ? `${percentageChange(
                      reportData.activityRes.facets.contract_signed.current_period.resale_condo.count,
                      reportData.activityRes.facets.contract_signed.prior_year_period.resale_condo.count
                    )}%`
                  : "0"
              } Year-over-Year`}
            />
            <Cards
              name="CO-OP"
              price={   validateNestedData(reportData, `activityRes.facets.contract_signed.current_period.resale_coop.count`)? reportData.activityRes.facets.contract_signed.current_period.resale_coop.count:"--" }
                     subContent1={`${
                (reportData.activityRes && reportData.activityRes.facets&& reportData.activityRes.facets.contract_signed && reportData.activityRes.facets.contract_signed.by_time && reportData.activityRes.facets.contract_signed.by_time.buckets && reportData.activityRes.facets.contract_signed.by_time.buckets.length && reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-1] && reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-1].resale_coop) &&
                (reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-2] && reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-2].resale_coop)
                  ? `${percentageChange(
                      reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-1].resale_coop.count,
                      reportData.activityRes.facets.contract_signed.by_time.buckets[reportData.activityRes.facets.contract_signed.by_time.buckets.length-2].resale_coop.count
                    )}%`
                  : "0"
              } ${genrateLabel()}`}
              subContent2={`${
                validateNestedData(reportData, "activityRes.facets.contract_signed.current_period.resale_coop.count") &&
                validateNestedData(reportData, "activityRes.facets.contract_signed.prior_year_period.resale_coop.count")
                  ? `${percentageChange(
                      reportData.activityRes.facets.contract_signed.current_period.resale_coop.count,
                      reportData.activityRes.facets.contract_signed.prior_year_period.resale_coop.count
                    )}%`
                  : "0"
              } Year-over-Year`}
            />
          </div>
        </div>
        <div className="building-view-summary-container">
          <p className="building-view-summary-text editable">
            {AiResponse && AiResponse.neighborhood_contract_analysis ? AiResponse.neighborhood_contract_analysis : <CustomSkeleton count={16}/>}
            
          </p>
        </div>
        <MultipleBarCharts
          data={reportData.activityRes.facets.contract_signed.by_time.buckets.slice(reportData.activityRes.facets.contract_signed.by_time.buckets.length-24, reportData.activityRes.facets.contract_signed.by_time.buckets.length).map(
            (data) => ({
              date: formatDateRange(null, null,data.val),
              NewDev:
                data && data.newdev && data.newdev.count
                  ? data.newdev.count
                  : 0,
              Condo:
                data && data.resale_condo && data.resale_condo.count
                  ? data.resale_condo.count
                  : 0,
              Coop:
                data && data.resale_coop && data.resale_coop.count
                  ? data.resale_coop.count
                  : 0,
            })
          )}
          theme={theme}
          height={700}
          isWeekly={dateOptions.gap}
        />
      </section>
     <Footer />
    </div>
    <div className="report-container page-section neighborhood">
      <h3 className="editable building-location">{reportData.buildingRes.building[0].neighborhood[0].toUpperCase()}</h3>
      <h3 className="header-text heading-location editable">
        NEIGHBORHOOD ANALYSIS
      </h3>
      <section className="report-section">
        <div className="card-main-container">
          <h3 className="building-view-header editable">Price</h3>
          <div className="building-view-text-wrapper">
            <div className="building-view-text">
              {`Average Sold Price / SF in ${reportData.buildingRes.building[0].neighborhood[0]}`}
            </div>
            <div>{`/ ${currentPeriodName}`}</div>
          </div>
          <div className="report-cards-container">
            <Cards
              name="NEW DEV"
              price={ reportData.priceTrendRes &&
                reportData.priceTrendRes.length > 1 &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].newdev &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].newdev.avg_ppsf ?`$${_formatNumber(
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1]
                  .newdev.avg_ppsf
              )}`:"--"}
              subContent1={`${
                reportData.priceTrendRes &&
                reportData.priceTrendRes.length > 1 &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].newdev &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].newdev.avg_ppsf &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 2] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 2].newdev &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 2].newdev.avg_ppsf
                  ? `${percentageChange(
                      reportData.priceTrendRes[reportData.priceTrendRes.length - 1].newdev.avg_ppsf,
                      reportData.priceTrendRes[reportData.priceTrendRes.length - 2].newdev.avg_ppsf
                    )}%`
                  : "0"
              } ${genrateLabel()}`}
              subContent2={`${
                reportData.priceTrendRes &&
                reportData.priceTrendRes.length > 1 &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].newdev &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].newdev.avg_ppsf && priceTrendOneYearBack && priceTrendOneYearBack.newdev && priceTrendOneYearBack.newdev.avg_ppsf
                  ? `${percentageChange(
                       reportData.priceTrendRes[reportData.priceTrendRes.length - 1].newdev.avg_ppsf ,
                    priceTrendOneYearBack.newdev.avg_ppsf
                    )}%`
                  : "0"
              } Year-over-Year`}
             
            />
            <Cards
              name="CONDO "
              price={reportData.priceTrendRes &&
                reportData.priceTrendRes.length > 1 &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].condo &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].condo.avg_ppsf? `$${_formatNumber(
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1]
                  .condo.avg_ppsf
              )}`:"--"}
              subContent1={`${
                reportData.priceTrendRes &&
                reportData.priceTrendRes.length > 1 &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].condo &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].condo.avg_ppsf &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 2] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 2].condo &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 2].condo.avg_ppsf
                  ? `${percentageChange(
                      reportData.priceTrendRes[reportData.priceTrendRes.length - 1].condo.avg_ppsf,
                      reportData.priceTrendRes[reportData.priceTrendRes.length - 2].condo.avg_ppsf
                    )}%`
                  : "0"
              } ${genrateLabel()}`}
              
              subContent2={`${
                reportData.priceTrendRes &&
                reportData.priceTrendRes.length > 1 &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].condo &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].condo.avg_ppsf && priceTrendOneYearBack && priceTrendOneYearBack.condo && priceTrendOneYearBack.condo.avg_ppsf
                  ? `${percentageChange(
                       reportData.priceTrendRes[reportData.priceTrendRes.length - 1].condo.avg_ppsf ,
                     priceTrendOneYearBack && priceTrendOneYearBack.condo && priceTrendOneYearBack.condo.avg_ppsf
                    )}%`
                  : "0"
              } Year-over-Year`}
            />
            <Cards
              name="CO-OP"
              price={reportData.priceTrendRes &&
                reportData.priceTrendRes.length > 1 &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].coop &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].coop.avg_ppsf? `$${_formatNumber(
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1]
                  .coop.avg_ppsf
              )}`:"--"}
              subContent1={`${
                reportData.priceTrendRes &&
                reportData.priceTrendRes.length > 1 &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].coop &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].coop.avg_ppsf &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 2] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 2].coop &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 2].coop.avg_ppsf
                  ? `${percentageChange(
                      reportData.priceTrendRes[reportData.priceTrendRes.length - 1].coop.avg_ppsf,
                      reportData.priceTrendRes[reportData.priceTrendRes.length - 2].coop.avg_ppsf
                    )}%`
                  : "0"
              } ${genrateLabel()}`}
              
              subContent2={`${
                reportData.priceTrendRes &&
                reportData.priceTrendRes.length > 1 &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1] &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].coop &&
                reportData.priceTrendRes[reportData.priceTrendRes.length - 1].coop.avg_ppsf && priceTrendOneYearBack && priceTrendOneYearBack.coop && priceTrendOneYearBack.coop.avg_ppsf
                  ? `${percentageChange(
                       reportData.priceTrendRes[reportData.priceTrendRes.length - 1].coop.avg_ppsf ,
                     priceTrendOneYearBack && priceTrendOneYearBack.coop && priceTrendOneYearBack.coop.avg_ppsf
                    )}%`
                  : "0"
              } Year-over-Year`}
            />
          </div>
        </div>
        <div className="building-view-summary-container">
          <p className="building-view-summary-text editable">
            {AiResponse && AiResponse.neighborhood_price_analysis ? AiResponse.neighborhood_price_analysis : <CustomSkeleton count={16}/>}
            
          </p>
        </div>
        <MultipleLineCharts
          data={processChartData(
              reportData.priceTrendRes.slice(
                reportData.priceTrendRes.length - 24,
                reportData.priceTrendRes.length
              )
            )}
          theme={theme}
          height={700}
          isWeekly={dateOptions.gap}
        />
      </section>
      <Footer />
    </div>
  </>
  );
};

export default BlendedLayout;
